export default __webpack_public_path__ + "static/media/AMZ1.6bdcd54c.png";